import React, {Component} from "react";
import _ from "lodash";
import RowPhoto from "../../../common/TdImg";

class ResultTable extends Component {
    state = {
        student: [],
    };

    columns = [
        {path: "id", label: "شماره",  width: "60px"},
        {path: "subject_name", label: "مظامین"},
        {path: "subject_code", label: "کد",  width: "80px"},
        {path: "tafkik", label: "تفکیک",  width: "60px"},
        {path: "credits", label: "کریدیت",  width: "60px"},
        {path: "first_chance_total", label: "اول", rotate: true, width: "60px"},
        {path: "second_chance_total", label: "دوم", rotate: true,  width: "60px"},
        {path: "final_total", label: "نهایی", rotate: true,  width: "60px"},
    ];


    componentDidMount = () => {
        const {student} = this.props;
        this.setState({student});
    };

    render() {
        const columns = this.columns;
        const {student} = this.state;

        let {counter} = this.props;
        const startIndex = counter - 1;
        const maxRows = counter + 4;

        console.log(student?.subjects);
        return (
                <div className="print-table-area" style={{
                    width: "calc(100% / 3)",
                    minHeight: "100%"
                }}>
                <table  style={{border: "1px solid #c1c1c1", borderRadius: "5px", height: "100%"}}>
                    {/* Table Header */}
                    <thead>
                    <tr>
                        {columns &&
                            columns.map(({key, path, label, rotate, width}) => (
                                <th style={{border: "1px solid #c1c1c1", background: "none", width: width}} key={key || path}>
                                    <div style={{color: "var(--blue)", transform: rotate ? "rotate(-90deg)": "none", textAlign: "center" }}>{label}</div>
                                </th>
                            ))}
                    </tr>
                    </thead>


                    {/* Table Body */}
                    <tbody>{
                        student?.subjects &&
                        student?.subjects[0]?.map((item, i) => {
                        // if startIndex is grater than current index don't display them
                        if(startIndex > i) return null;

                        // if we have more than 4 rows don't display them
                        if(counter >= maxRows) return null;


                        return (<tr key={i}>
                            {columns && columns.map((column) =>
                                <td style={{border: "1px solid #c1c1c1"}}
                                    key={item.id + (column.path || column.key)}>
                                    {column.path === "id" ? counter++ : _.get(item, column.path)}
                                </td>)}
                        </tr>)
                    })}</tbody>
                </table>
            </div>
        );
    }
}

export default ResultTable;
